export const SET_ACTIVITY_INFO = 'SET_ACTIVITY_INFO';
export const UPDATE_ACTIVITY_PROPERTY = 'UPDATE_ACTIVITY_PROPERTY';
export const UPDATE_ACTIVITY_PROPERTIES = 'UPDATE_ACTIVITY_PROPERTIES';
export const SET_ACTIVITY_SECTION = 'SET_ACTIVITY_SECTION';
export const SET_ACTIVITY_VALIDATIONS = 'SET_ACTIVITY_VALIDATIONS';
export const SET_ACTIVITY_PROPERTY_VALIDITY = 'SET_ACTIVITY_PROPERTY_VALIDITY';
export const REPLACE_ACTIVITY_SECTIONS_VALIDITY = 'REPLACE_ACTIVITY_SECTIONS_VALIDITY';
export const FETCH_ACTIVITY_SECTION = 'FETCH_ACTIVITY_SECTION';
export const SET_PICKER_DATA = 'SET_PICKER_DATA';
export const SET_LOADING = 'SET_LOADING';
export const ADD_ACTIVITY_VALIDATIONS = 'ADD_ACTIVITY_VALIDATIONS';
export const REMOVE_ACTIVITY_VALIDATIONS = 'REMOVE_ACTIVITY_VALIDATIONS';
export const SET_SECTIONS_LOADING = 'SET_SECTIONS_LOADING';
export const SET_SECTIONS_LOADED = 'SET_SECTIONS_LOADED';
export const RESET_TEMP_DATA = 'RESET_TEMP_DATA';
export const SET_TEMP_DATA = 'SET_TEMP_DATA';
